"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
function LocalStorage(name) {
    var currentValue = localStorage.getItem(name);
    var addrList = JSON.parse(currentValue);
    function setValues(val) {
        addrList = addrList ? addrList : [];
        if (addrList.indexOf(val) == -1) {
            addrList.push(val);
            localStorage.setItem(name, JSON.stringify(addrList));
        }
    }
    function removeValue(index) {
        addrList.splice(index, 1);
        localStorage.setItem(name, JSON.stringify(addrList));
    }
    return [addrList, setValues, removeValue];
}
exports.LocalStorage = LocalStorage;
